import { render, staticRenderFns } from "./collapse-item.vue?vue&type=template&id=58de7e57&scoped=true&"
import script from "./collapse-item.vue?vue&type=script&lang=js&"
export * from "./collapse-item.vue?vue&type=script&lang=js&"
import style0 from "./collapse-item.vue?vue&type=style&index=0&id=58de7e57&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58de7e57",
  null
  
)

export default component.exports